import React from 'react';

import { InlineMath, BlockMath } from 'react-katex';
import 'katex/dist/katex.min.css';

function ReservoirConstruction() {
  return (
    <div className="row">
      <div className="col-12">
        <p>
          Our goal is to implement a random, large, fixed recurrent neural network.
          We utilize 100% neuron connectivity in our hidden layer and do not employ noise injection or other hyper-parameters.
        </p>
        <p>
          The reservoir is governed by the <strong>state update equation</strong>
        </p>
        <BlockMath>{`x_{n+1}=\\tanh(W_{in}u_{n+1}+Wx_{n}+W_{fb}y_{n})`}</BlockMath>
        <p>
          During state harvesting, we drive the ESN with input sequence <InlineMath>{` u(1),...,u(n_{nmax}) `}</InlineMath> using our state update equation.
          We obtain the <strong>extended system state</strong> by concatenating reservoir and input states <InlineMath>z(n) = [x(n);u(n)]</InlineMath>.
          The extended system states are filed row-wise into a <strong>state collection matrix</strong> <InlineMath>S</InlineMath>.
        </p>
        <p>
          Data is generated from two models. These serve as both the teacher output and the <strong>desired output</strong> <InlineMath>d(n)</InlineMath>.
          The <strong>output collection matrix</strong> <InlineMath>D</InlineMath> is filled row-wise with our desired outputs.
        </p>
        <p>
          The <strong>desired output weights</strong> <InlineMath>{` W^{out} `}</InlineMath>, used to transform reservoir states to outputs, is computed
          <BlockMath>{` W^{out} = (S^{\\dag}D)^{T} \\; \\tiny ^{\\dag} pseudoinverse`}</BlockMath>
        </p>
      </div>
    </div>
  );
}

export default ReservoirConstruction;
